"use client";

import { createContext } from "@pharaday/utils";

import type { Shortcut } from "../../core/domain/shortcut";
import type { CommandShortcut } from "./provider";

export type CommandShortcutContext = {
  clear: () => void;
  /**
   * Adds a new command shortcuts with a specified shortcut and command. If an element with the same shortcut already exists, it will be updated.
   */
  set: (commandShortcuts: CommandShortcut) => void;
  /**
   * @returns true if existed command shortcut and has been removed, or false if the command shortcut does not exist.
   */
  remove: (shortcut: Shortcut) => boolean;
  /**
   *
   * @returns Returns the element associated with the specified key. If no element is associated with the specified key, undefined is returned.
   */
  get: (shortcut: Shortcut) => CommandShortcut | undefined;
  /**
   *
   * @returns Returns all command shortcuts
   */
  getAll: () => CommandShortcut[];
};

export const [useCommandShortcutContext, CommandShortcutContextProvider] = createContext<CommandShortcutContext>();
